import React, { useState } from "react";
import "../styles/Navbar.css";
import { Outlet, Link } from "react-router-dom";

function Navbar() {
  const [btn, setBtn] = useState(false);
  const [toggleStyle, setToggleStyle] = useState("");

  const displayNav = () => {
    if (btn) {
      setBtn(false);
      setToggleStyle("");
    } else {
      setBtn(true);
      setToggleStyle("inline-block");
    }
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-dark bg-primary">
        <Link id="firstLink" to="/" className="navbar-brand">
          Queries API
        </Link>
        <button className="navbar-toggler" type="button" onClick={displayNav}>
          <span className="navbar-toggler-icon"></span>
        </button>

        <div
          className="collapse navbar-collapse"
          id="navbarSupportedContent"
          style={{ display: toggleStyle }}
        >
          <ul className="navbar-nav mr-auto">
            <li className="nav-item active">
              <Link to="/" className="nav-link">
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/astrology" className="nav-link">
                Astrology
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/weather" className="nav-link">
                Weather
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/news" className="nav-link">
                News
              </Link>
            </li>
          </ul>
        </div>
      </nav>
      <Outlet />
    </>
  );
}

export default Navbar;
